import { render, staticRenderFns } from "./ProjectsDigests.vue?vue&type=template&id=7d9365f1&scoped=true"
import script from "./ProjectsDigests.vue?vue&type=script&lang=js"
export * from "./ProjectsDigests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9365f1",
  null
  
)

export default component.exports